"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserCheckedInToVenueDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const Venue_dto_1 = require("../response/Venue.dto");
class UserCheckedInToVenueDto {}
exports.UserCheckedInToVenueDto = UserCheckedInToVenueDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserCheckedInToVenueDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserCheckedInToVenueDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserCheckedInToVenueDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserCheckedInToVenueDto.prototype, "gender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.SubGender,
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UserCheckedInToVenueDto.prototype, "subGender", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserCheckedInToVenueDto.prototype, "preferredGender", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Array)], UserCheckedInToVenueDto.prototype, "preferredGenders", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether preferred genders should be shown on the viewer UI.'
}), __metadata("design:type", Boolean)], UserCheckedInToVenueDto.prototype, "showGenderPreferences", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserCheckedInToVenueDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], UserCheckedInToVenueDto.prototype, "age", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UserCheckedInToVenueDto.prototype, "isBlockingMe", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UserCheckedInToVenueDto.prototype, "isBlockedByMe", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UserCheckedInToVenueDto.prototype, "isLikingMe", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UserCheckedInToVenueDto.prototype, "isLikedByMe", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Venue_dto_1.VenueDto)], UserCheckedInToVenueDto.prototype, "currentVenue", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserCheckedInToVenueDto.prototype, "currentVenueCheckedInAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserCheckedInToVenueDto.prototype, "secondsInVenue", void 0);
//# sourceMappingURL=UserCheckedInToVenue.dto.js.map